export default __webpack_public_path__ + "static/media/estimated-survival.a0c57327.jpg";